module.exports = __webpack_public_path__ + "static/media/glassesimoji.5500a606.png";